import React from 'react'
import './Academic.css'
const Academic = () => {
    return (
        <div>
            <div className="cardContainer">
                <div className="myCard mt-5">
                    <div className="innerCard m-3">
                        <div className="frontSide m-3">
                            <p className="title">
                                B.Sc. CSIT</p>
                            <span>12 Batches</span>
                        </div>
                        <div className="backSide">
                                <img className='image' src="https://scontent.fktm3-1.fna.fbcdn.net/v/t39.30808-6/330578801_1301689417080249_7675227939090825252_n.jpg?_nc_cat=107&ccb=1-7&_nc_sid=49d041&_nc_ohc=BPP_y9wbGDAAX9fhDD1&_nc_ht=scontent.fktm3-1.fna&oh=00_AfCXKgKVZITVjU7NUIo93fH9OsOXFz0yc8gy2Q8oCuAwug&oe=64F78CAD" alt="" />
                        </div>
                    </div>
                </div>

                <div className="myCard mt-5">
                    <div className="innerCard m-3">
                        <div className="frontSide m-3">
                            <p className="title">BCA</p>
                            <span>5 Batches</span>
                        </div>
                        <div className="backSide">
                                <img className='image' src="https://scontent.fktm3-1.fna.fbcdn.net/v/t39.30808-6/330578801_1301689417080249_7675227939090825252_n.jpg?_nc_cat=107&ccb=1-7&_nc_sid=49d041&_nc_ohc=BPP_y9wbGDAAX9fhDD1&_nc_ht=scontent.fktm3-1.fna&oh=00_AfCXKgKVZITVjU7NUIo93fH9OsOXFz0yc8gy2Q8oCuAwug&oe=64F78CAD" alt="" />
                        </div>
                    </div>
                </div>

                <div className="myCard mt-5">
                    <div className="innerCard m-3">
                        <div className="frontSide m-3">
                            <p className="title">Total Students</p>
                            <span>612</span>
                        </div>
                        <div className="backSide">
                                <img className='image' src="https://scontent.fktm3-1.fna.fbcdn.net/v/t39.30808-6/330578801_1301689417080249_7675227939090825252_n.jpg?_nc_cat=107&ccb=1-7&_nc_sid=49d041&_nc_ohc=BPP_y9wbGDAAX9fhDD1&_nc_ht=scontent.fktm3-1.fna&oh=00_AfCXKgKVZITVjU7NUIo93fH9OsOXFz0yc8gy2Q8oCuAwug&oe=64F78CAD" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Academic
